<template>
  <div id="editor">
    <textarea :value="input" @input="update"></textarea>
    <div v-html="compiledMarkdown" id="editor-output"></div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import marked from 'marked'

export default {
  data () {
    return {
      input: '# hello'
    }
  },
  computed: {
    compiledMarkdown: function () {
      return marked(this.input, {sanitize: true})
    }
  },
  methods: {
    update: debounce(function (e) {
      this.input = e.target.value
    }, 300)
  },
  created () {
    let mdeditor_src1 = document.createElement('script');
    mdeditor_src1.setAttribute('src', "https://unpkg.com/marked@0.3.6");
    document.head.appendChild(mdeditor_src1)

    let mdeditor_src2 = document.createElement('script');
    mdeditor_src1.setAttribute('src', "https://unpkg.com/lodash@4.16.0");
    document.head.appendChild(mdeditor_src2)
  }
}
</script>

<style scoped>
html, body, #editor {
  margin: 0;
  height: 100%;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #000;
}

textarea, #editor div {
  display: inline-block;
  width: 49%;
  height: 100%;
  vertical-align: top;
  box-sizing: border-box;
  padding: 0 20px;
}

textarea {
  border: none;
  border-right: 1px solid #ccc;
  resize: none;
  outline: none;
  background-color: #f6f6f6;
  font-size: 14px;
  font-family: 'Monaco', courier, monospace;
  padding: 20px;
}

code {
  color: #f66;
}

#editor-output {
  background-color: #f6f6f6;
}
</style>



// WEBPACK FOOTER //
// src/layouts/sandbox/examples/mdEditor.vue